import SVG from "react-inlinesvg";
export const SVGWrapper = ({ src, style, className }) => (
  <SVG className={className} src={src} />
);
